'use strict'
import axios from 'axios';
import router from "../router";
import items from "@/store/index.js";
var aes256 = require("aes256");
var keyAes256 = "d41d8cd98f00b204e9800998ecf8427e";
var serverBase = "https://raceapp.didevelopment.pl/api/"
var server = "https://raceapp.didevelopment.pl/api/User/authenticate";
var serverUser = "https://raceapp.didevelopment.pl/api/User/get-by-id/1";
var func ={
    login(){
        if(localStorage.login!=null){
            var login = aes256.decrypt(keyAes256,localStorage.login),
                password = aes256.decrypt(keyAes256,localStorage.password);
            items.state.name = login;
            items.state.stan = null;
            axios.post(server,{"login":login, "password":password,})
            .then(response => {
                if(response.status==200){
                    console.log(response)
                    console.log("Autoryzacja pomyślna")
                    localStorage.stan = items.state.stan = 'zalogowano'
                    sessionStorage.login_active=true
                    localStorage.token = items.state.token = response.data.token
                    router.push({name:'dashboard'})
                }
            })
            .catch(err => {
                localStorage.stan = null;
                console.log(err)
                router.push({name:'login'})
            })

            // const options = {
            //     method:'POST',
            //     headers:{
            //         'Accept': 'application/json',
            //         'Content-Type': 'application/json;charset=UTF-8'
            //     },
            //     body:JSON.stringify({
            //         "login":login, 
            //         "password":password 
            //     })
            // }
            // fetch(server,options)
            // .then(response=> response.json())
            // .then(data =>  {
            //         console.log(data)
            //         console.log("Autoryzacja pomyślna")
            //         localStorage.stan = items.state.stan = 'zalogowano'
            //         localStorage.token = items.state.token = data.token
            //         router.push({name:'dashboard'})
            // })
            // .then(headers=>{console.log(headers)})            
        }
    },
    logout(){
        localStorage.stan = localStorage.login = localStorage.password = localStorage.token = null;
        sessionStorage.login = sessionStorage.password = null;
        sessionStorage.login_active=false;
        items.dispatch('logoutClearData')
        router.push({name:'login'})
    },
    getUserData(){
         let authToken = JSON.stringify(localStorage.token)
        //let authToken ="Bearer ".concat(localStorage.token)
        console.log(authToken)
        let cookieData = document.cookie
        console.log(cookieData)

        //---------> korzystajac z biblioteki axios o tworząc promise
        // const request =require('axios')
        // async function makeRequest(){
        //     const config = {
        //         method:'get',
        //         url: serverUser,
        //         headers:{'Authorization':authToken,'Content-Type': 'application/json'}
        //     }
        //     let res = await request(config)
        //     items.state.userData = res.response
        // }
        // makeRequest();

        // ------> korzystajac z biblioteki axios
        const axiosConfig = {
            mode: 'no-cors',
            headers: {
            'content-Type': 'application/json',
            "Accept": "/",
            "Cache-Control": "no-cache",
            "Cookie":cookieData,
            "Authorization": authToken, 
            },
            withCredentials: false,
        };
            axios.get(serverUser,
            axiosConfig)
            .then((res) => {
                items.state.UserData = res.data
            })
            .catch((err) => {
            console.log(err+':(');
            router.push({name:'login'})
            });
        


        // axios.get( serverUser, { headers:{ Authorization: `Bearer ${authToken}`, Cookie: `${cookieData}`}})
        // .then(response => {
        //     items.state.UserData = response.data;
        // })
        // .catch(err => {
        //     console.log(err)
        //     router.push({name:'login'})
        // })

        // fetch do poboru danych użytkownika
        // const optionsGet = {
        //     method:'GET',
        //     headers:{
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json;charset=UTF-8',
        //         'Authorization': `Bearer ${authToken}`,
        //         'Cookie': `${document.cookie}`
        //     }
        // }
        // fetch(serverUser,optionsGet)
        // .then(response=> response.json())
        // .catch(err=>console.log(err))
        // .then(data =>  {
        //         console.log(data)
        //         console.log("Pobrano dane")
        //         items.state.UserData  =  data;
        // })
        

    },
    fetchLeagues(){
        let endpoint = "league/get-list"
        axios.get(serverBase+endpoint)
                .then(response=>{
                    items.state.leagues = response.data
                })
    }
}
export default func